import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

//Funciones comunes
import { LogErrors } from './../../utilities/LogErrors'
import { useLanguage } from './../../utilities/LanguageContext'
import { SignUp as BLSignUp, GetAllStates, GetCalculateDateRange, GetMajorsByNormalSchool, GetNormalSchoolsByState, GetNormalSchoolSectors, GetStatesContracted, ValidateAverageData } from './../../utilities/BL/SignUps'

import { DeleteSignUpInfo } from './../../utilities/BL/Sessions'

//Componentes comunes
import { Input } from './../Commons/Forms/SignUp/Fields/Input'
import { Select } from './../Commons/Forms/SignUp/Fields/Select'
import { Loading } from './../Commons/Loading'
import { SignUpHeader } from './../Commons/Header/SignUpHeader'
import { GoToTop } from './../Commons/GoToTop'
import { GoToBack } from './../Commons/GoToBack'
import { SetDefaultWebTheme } from './../../utilities/BL/Settings'


const SignUp = () => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()

    const [minDate, setMinDate] = useState('')
    const [maxDate, setMaxDate] = useState('')

    const [states, setStates] = useState([]) // Lista de estados
    const [sectors, setSectors] = useState([]) // Lista de sectores
    const [normalStates, setNormalStates] = useState([]) // Lista de estados de escuelas normales contratadas
    const [schools, setSchools] = useState([]) // Lista de escuelas
    const [majors, setMajors] = useState([]) // Lista de especialidades
    

    //Estados
    const [formData, setFormData] = useState({
        name: '',
        paternalSurname: '',
        maternalSurname: '',
        birthdate: '',
        nameOfHomeSchool: '',
        nameState: '',
        state: '',
        nameSector: '',
        sector: '',
        average: '',
        nameNormalState: '',
        normalState: '',
        nameNormalSchool: '',
        normalSchool: '',
        nameMajor: '',
        major: ''
    }) // Estado que maneja la info del formulario
    const [errors, setErrors] = useState({}) // Estado que maneja los errores
    const [isSubmitted, setIsSubmitted] = useState(false) // Estado que controla si se ha enviado, o no, el formulario
    const [isLoading, setIsLoading] = useState(true) // Estado qude carga
    const [isButtonLoading, setIsButtonLoading] = useState(false)

    //Objetos que almacenan los controles del formulario
    const nameRef = useRef(null)
    const paternalSurnameRef = useRef(null)
    const maternalSurnameRef = useRef(null)
    const birthdateRef = useRef(null)
    const nameOfHomeSchoolRef = useRef(null)
    const statesRef = useRef(null)
    const sectorsRef = useRef(null)
    const averageRef = useRef(null)
    const normalStateRef = useRef(null)
    const normalSchoolRef = useRef(null)
    const majorsRef = useRef(null)


    //--- Funciones personalizadas ---//
    const LoadPage = async () => {
        try {
            //Establecer el tema a la web
            await SetDefaultWebTheme()
            

            //Establecer el tema claro a la web
            document.body.classList.remove('DarkTheme')
            document.getElementById("root").classList.add("BodyComplete")

            await DeleteSignUpInfo()

            
            const today = new Date()
            const responseDate = await GetCalculateDateRange(today)
            
            if (responseDate.success) {
                setMinDate(responseDate.data.minDate)
                setMaxDate(responseDate.data.maxDate)

                const states = await GetAllStates()
                if (states.success) {
                    setStates(states.data)
                }

                const sectors = await GetNormalSchoolSectors()
                if (sectors.success) {
                    setSectors(sectors.data)
                }

                const normalStates = await GetStatesContracted()
                if (normalStates.success) {
                    setNormalStates(normalStates.data)
                }
            } else {
                //Mostrar mensaje de error
                console.log(responseDate.message)
            }
        } catch (error) {
            await LogErrors('LoadPage - SignUp', error)
        } finally {
            setIsLoading(false)
        }
    }

    const GetStateName = async (stateId) => {
        try {
            if (stateId === null) {
                return null
            }

            if (isNaN(stateId)) {
                return null
            }

            const state = states.filter(state => state.id === parseInt(stateId))

            if (state.length === 0) { return '' }
            if (state[0].name === '') { return '' }

            return state[0].name
        } catch (error) {
            await LogErrors('GetStateName - SignUp', error)
        }
    }

    const GetSectorName = async (sectorId) => {
        try {
            if (sectorId === null) {
                return null
            }

            if (isNaN(sectorId)) {
                return null
            }

            const sector = sectors.filter(sector => sector.id === parseInt(sectorId))

            if (sector.length === 0) { return '' }
            if (sector[0].name === '') { return '' }

            return sector[0].name
        } catch (error) {
            await LogErrors('GetSectorName - SignUp', error)
        }
    }

    const GetSchoolName = async (schoolId) => {
        try {
            if (schoolId === null) {
                return null
            }

            if (isNaN(schoolId)) {
                return null
            }

            const school = schools.filter(school => school.id === parseInt(schoolId))

            if (school.length === 0) { return '' }
            if (school[0].name === '') { return '' }
            
            return school[0].name
        } catch (error) {
            await LogErrors('GetSchoolName - SignUp', error)
        }
    }

    const GetNormalStateName = async (normalStateId) => {
        try {
            if (normalStateId === null) {
                return null
            }

            if (isNaN(normalStateId)) {
                return null
            }

            const normalState = normalStates.filter(normalState => normalState.id === parseInt(normalStateId))

            if (normalState.length === 0) { return '' }
            if (normalState[0].name === '') { return '' }

            return normalState[0].name
        } catch (error) {
            await LogErrors('GetNormalStateName - SignUp', error)
        }
    }

    const GetMajorName = async (majorId) => {
        try {
            if (majorId === null) {
                return null
            }

            if (isNaN(majorId)) {
                return null
            }

            const major = majors.filter(major => major.id === parseInt(majorId))

            if (major.length === 0) { return '' }
            if (major[0].name === '') { return '' }

            return major[0].name
        } catch (error) {
            await LogErrors('GetMajorName - SignUp', error)
        }
    }

    const SignUp = async (e) => {
        try {
            e.preventDefault()
            setIsButtonLoading(true)

            setIsSubmitted(true) // Marcar el formulario como enviado
            
            const formDataToSubmit = {
                ...formData,
                state: parseInt(formData.state) || null,
                nameState: await GetStateName(formData.state),
                sector: parseInt(formData.sector) || null,
                nameSector: await GetSectorName(formData.sector),
                normalState: parseInt(formData.normalState) || null,
                nameNormalState: await GetNormalStateName(formData.normalState),
                normalSchool: parseInt(formData.normalSchool) || null,
                nameNormalSchool: await GetSchoolName(formData.normalSchool),
                major: parseInt(formData.major) || null,
                nameMajor: await GetMajorName(formData.major)
            }
            
            const response = await BLSignUp(formDataToSubmit, minDate, maxDate, schools, states, majors)
            
            if (response.success) {
                navigate('/registered-applicant')
            } else {
                if (typeof response.message === 'string') {
                    setErrors(response.message)
                } else {
                    setErrors(response.message.formErrors)
                    
                    // Muestra los errores y haz focus en el campo correspondiente
                    if (response.message.formErrors.name) {
                        nameRef.current.focus()
                    } else if (response.message.formErrors.paternalSurname) {
                        paternalSurnameRef.current.focus()
                    } else if (response.message.formErrors.maternalSurname) {
                        maternalSurnameRef.current.focus()
                    } else if (response.message.formErrors.birthdate) {
                        birthdateRef.current.focus()
                    } else if (response.message.formErrors.nameOfHomeSchool) {
                        nameOfHomeSchoolRef.current.focus()
                    } else if (response.message.formErrors.states) {
                        //statesRef.current.focus()
                    } else if (response.message.formErrors.sectors) {
                        //sectorsRef.current.focus()
                    } else if (response.message.formErrors.average) {
                        averageRef.current.focus()
                    } else if (response.message.formErrors.normalState) {
                        //normalStateRef.current.focus()
                    } else if (response.message.formErrors.normalSchool) {
                        //normalSchoolRef.current.focus()
                    } else if (response.message.formErrors.majors) {
                        //majorsRef.current.focus()
                    }
                }
            }
        } catch (error) {
            await LogErrors('SignUp - SignUp', error)
        } finally {
            setIsButtonLoading(false)
        }
    }
    //--- Funciones personalizadas ---//


    //--- Eventos de la página web ---//
    useEffect(() => {
        LoadPage()
    },[]) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar
    //--- Eventos de la página web ---//


    //--- Eventos de formulario ---//
    /**
     * @param {Event} e 
     */
    const InputChange = async (e) => {
        try {
            const { id, value, type, checked } = e.target
      
            setFormData({
                ...formData,
                [id]: type === 'checkbox' ? checked : value
            })
        } catch (error) {
            await LogErrors('InputChange - SignUp', error)
        }
    }

    const StateListChange = async (e) => {
        try {
            setFormData({
                ...formData,
                state: e.target.value // Actualizar la selección de estado
            })
        } catch (error) {
            await LogErrors('StateListChange - SignUp', error)
        }
    }

    const SectorsListChange = async (e) => {
        try {
            setFormData({
                ...formData,
                sector: e.target.value // Actualizar la selección de sector
            })
        } catch (error) {
            await LogErrors('SectorsListChange - SignUp', error)
        }
    }

    const AverageFieldChange = async (e) => {
        try {
            const response = await ValidateAverageData(e.target.value)
            
            if (response.success) {
                setFormData({
                    ...formData,
                    average: response.data // Actualizar el estado solo si es válido
                })
            // } else {
            //     //Mostrar mensaje de error
            //     console.log(response.message)
            }
        } catch (error) {
            await LogErrors('AverageFieldChange - SignUp', error)
        }
    }

    const NormalStateListChange = async (e) => {
        try {
            const stateId = e.target.value
      
            // Actualizar el estado seleccionado
            setFormData({
                ...formData,
                normalState: stateId,
                normalSchool: '', // Reinicia la selección de escuela
                major: '' // Reinicia la selección de especialidad
            })
            
            const response = await GetNormalSchoolsByState(stateId)
            
            if (response.success) {
                //setFilteredSchools(response.data)
                setSchools(response.data)
            } else {
                setSchools([])
            }
            setMajors([]) // Reinicia la lista de especialidades
            //setFilteredMajors([]) // Reinicia la lista filtrada de especialidades
        } catch (error) {
            await LogErrors('NormalStateListChange - SignUp', error)
        }
    }

    const SchoolListChange = async (e) => {
        try {
            const schoolId = e.target.value

            setFormData({
                ...formData,
                normalSchool: schoolId, // Actualizar la selección de escuela
                major: '' // Reinicia la selección de especialidad
            })
            
            const response = await GetMajorsByNormalSchool(schoolId)
            
            if (response.success) {
                //setFilteredSchools(response.data)
                setMajors(response.data)
            } else {
                setMajors([])
            }
        } catch (error) {
            await LogErrors('SchoolListChange - SignUp', error)
        }
    }

    const MajorsListChange = async (e) => {
        try {
            setFormData({
                ...formData,
                major: e.target.value
            })
        } catch (error) {
            await LogErrors('MajorsListChange - SignUp', error)
        }
    }

    /**
     * Función que se ejecuta cuando se presiona la tecla Enter o se presiona el botón del formulario
     * @param {Event} e 
     */
    const FormSubmit = async (e) => {
        try {
            await SignUp(e)
        } catch (error) {
            await LogErrors('FormSubmit - SignUp', error)
        }
    }

    /**
     * Función que se ejecuta al presiona la tecla Enter en el formulario
     * @param {Event} e 
     */
    const EnterKeyPressInForm = async (e) => {
        try {
            if (e.key === 'Enter') {
                await SignUp(e)
            }
        } catch (error) {
            await LogErrors('EnterKeyPressInForm - SignUp', error)
        }
    }
    //--- Eventos de formulario ---//


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <SignUpHeader />

                <GoToBack url={'/'} className={'container'} />

                <main className='container Container-FullHeight Container-FlexContent SignUpMain'>
                    <div className='SignUpMain__Container'>
                        <form className='SignUpMain__Container__LoginForm' onSubmit={FormSubmit} onKeyPress={EnterKeyPressInForm}>
                            <p id='formTitle' className='SignUpMain__Container__LoginForm-Title'>{translate('labels.signUp.title')}</p>
        
                            <label htmlFor='name' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.name')}</label>
                            <Input
                                id='name'
                                type='text'
                                value={formData.name}
                                onChange={InputChange}
                                //placeholder={translate('labels.signUp.name')}
                                error={isSubmitted ? errors.name : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={nameRef}
                            />

                            <label htmlFor='paternalSurname' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.paternalSurname')}</label>
                            <Input
                                id='paternalSurname'
                                type='text' 
                                value={formData.paternalSurname}
                                onChange={InputChange}
                                //placeholder={translate('labels.signUp.paternalSurname')}
                                error={isSubmitted ? errors.paternalSurname : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={paternalSurnameRef}
                            />

                            <label htmlFor='maternalSurname' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.maternalSurname')}</label>
                            <Input
                                id='maternalSurname'
                                type='text' 
                                value={formData.maternalSurname}
                                onChange={InputChange}
                                //placeholder={translate('labels.signUp.maternalSurname')}
                                error={isSubmitted ? errors.maternalSurname : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={maternalSurnameRef}
                            />

                            <label htmlFor='birthdate' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.birthdate')}</label>
                            <Input
                                id='birthdate'
                                type='date' 
                                value={formData.birthdate}
                                onChange={InputChange}
                                //placeholder={translate('labels.signUp.birthdate')}
                                min={minDate} // Rango mínimo dinámico
                                max={maxDate} // Rango máximo dinámico
                                error={isSubmitted ? errors.birthdate : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={birthdateRef}
                            />

                            <label htmlFor='nameOfHomeSchool' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.nameOfHomeSchool')}</label>
                            <Input
                                id='nameOfHomeSchool'
                                type='text' 
                                value={formData.nameOfHomeSchool}
                                onChange={InputChange}
                                //placeholder={translate('labels.signUp.nameOfHomeSchool')}
                                error={isSubmitted ? errors.nameOfHomeSchool : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={nameOfHomeSchoolRef}
                            />

                            <label htmlFor="states" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.states.label')}</label> {/* Crear esta */}
                            <Select
                                id="states"
                                value={formData.states}
                                onChange={StateListChange} //Crear esta
                                options={states}
                                placeholder={translate('labels.signUp.states.defaultOption')}
                                error={isSubmitted ? errors.states : null}
                                isSubmitted={isSubmitted}
                                ref={statesRef}
                            />

                            <label htmlFor="sectors" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.sectors.label')}</label> {/* Crear esta */}
                            <Select
                                id="sectors"
                                value={formData.sectors}
                                onChange={SectorsListChange} //Crear esta
                                options={sectors}
                                placeholder={translate('labels.signUp.sectors.defaultOption')}
                                error={isSubmitted ? errors.sectors : null}
                                isSubmitted={isSubmitted}
                                ref={sectorsRef}
                            />

                            <label htmlFor='average' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.average')}</label>
                            <Input
                                id='average'
                                type='text' 
                                value={formData.average}
                                //onChange={InputChange}
                                onChange={AverageFieldChange}
                                //placeholder={translate('labels.signUp.average')}
                                error={isSubmitted ? errors.average : null} // Mostrar error solo si se ha enviado el formulario
                                isSubmitted={isSubmitted} // Pasar isSubmitted al Input
                                ref={averageRef}
                            />

                            <label htmlFor="normalState" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.normalState.label')}</label>
                            <Select
                                id="normalState"
                                value={formData.normalState}
                                onChange={NormalStateListChange}
                                options={normalStates}
                                placeholder={translate('labels.signUp.normalState.defaultOption')}
                                error={isSubmitted ? errors.normalState : null}
                                isSubmitted={isSubmitted}
                                ref={normalStateRef}
                            />

                            <label htmlFor="normalSchool" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.normalSchool.label')}</label>
                            <Select
                                id="normalSchool"
                                value={formData.normalSchool}
                                onChange={SchoolListChange}
                                options={schools} //filteredSchools
                                placeholder={translate('labels.signUp.normalSchool.defaultOption')}
                                error={isSubmitted ? errors.normalSchool : null}
                                disabled={!formData.normalState}
                                isSubmitted={isSubmitted}
                                ref={normalSchoolRef}
                            />

                            <label htmlFor="majors" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.majors.label')}</label>  {/* Crear esta */}
                            <Select
                                id="majors"
                                value={formData.majors}
                                onChange={MajorsListChange} //Crear esta
                                options={majors} //filteredMajors
                                placeholder={translate('labels.signUp.majors.defaultOption')}
                                error={isSubmitted ? errors.majors : null}
                                disabled={!formData.normalSchool}
                                isSubmitted={isSubmitted}
                                ref={majorsRef}
                            />

                            {isButtonLoading ? (
                                <button type='button' className='SignUpMain__Container__LoginForm-Button SignUpMain__Container__LoginForm-Button-Disabled'>{translate('labels.signUp.loadingSubmit')}</button>
                            ) : (
                                <button type='submit' className='SignUpMain__Container__LoginForm-Button'>{translate('labels.signUp.submit')}</button>
                            )}
                            {typeof errors.message === 'string' && <p className='error'>{errors}</p>}
                        </form>

                        <hr className='SignUpMain__Container__Divisor'></hr>
                
                        <div className='SignUpMain__Container__Buttons'>
                            <button type='button' onClick={() => navigate('/')} className='SignUpMain__Container__Buttons__Button--Disabled'>{translate('labels.signUp.login')}</button>
                        </div>
        
                        <div className='Login-Partners'>
                            <img src='/img/brand/dgesum-logotipo.png' alt='Logotipo-DEGESuM' className='Login-Partners-Logo' />
                            <img src='/img/brand/upn-logotipo.png' className='Login-Partners-Logo Login-Partners-Logo--UPN' />
                            <img src='/img/brand/edutest-logotipo.png' alt='Logotipo-EDUTEST' className='Login-Partners-Logo' />
                        </div>
                    </div>
                </main>
        
                <GoToTop />

                <footer className='Login-Footer'>
                    <p>{translate('labels.credits.footer')}</p>
                </footer>
            </>
        )
    )
}

export { SignUp };